const downloadFile = (file, name) => {
  var a = document.createElement("a");
  a.href = file;
  a.download = name;
  a.click();
};

export { downloadFile };